import { FormControl } from "@angular/forms";

export function StreetNameValidator(control: FormControl) {

	let valid = false;

	if (control.value) {
		const streetNameRegEx = /^(?!.*[- ']{2})(?![- '])(?!.*[- ]$)[a-zA-Z0-9 '-]+$/;
		//(/^(?!.*[-\s])(?!^[-\s])(?!.*[-\s]$)(([a-zA-Z0-9'-\s])+)*$/);

		valid = streetNameRegEx.test(control.value);

		if (!valid) {
			return {
				streetNameInvalid: {
					valid: false,
					message: "Invalid street name"
				}
			};
		} else {
			return null;
		}
	}
}
